import { styled } from 'linaria/react';
import { Link } from '@okapi/router-react';
import { breakpoints } from 'media';

export const Wrapper = styled(Link)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	width: 100%;
	color: var(--text-primary);
	border: 1px solid var(--control-minor);
	border-radius: 8px;
	text-decoration: none;

	${breakpoints.only.tablet} {
		grid-column: span 2;
	}
`;

export const MobileWrapper = styled(Link)`
	display: flex;
	padding: 16px;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	border-top: 1px solid var(--control-minor);
	text-decoration: none;
	color: inherit;
`;
